module.exports = __webpack_public_path__ + "static/img/wdzt1-10.eabc2c7.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdzt1-10.png
// module id = 424
// module chunks = 0